import Vue from "vue"
import Vuex from "vuex"
import api from "@/services/api"

Vue.use(Vuex)

var initial_coords = { lat: 53.520496, lng: -1.131775 }
function distance(lat1, lon1, lat2, lon2) {
  if (lat1 == lat2 && lon1 == lon2) {
    return 0
  } else {
    var radlat1 = (Math.PI * lat1) / 180
    var radlat2 = (Math.PI * lat2) / 180
    var theta = lon1 - lon2
    var radtheta = (Math.PI * theta) / 180
    var dist = Math.sin(radlat1) * Math.sin(radlat2) + Math.cos(radlat1) * Math.cos(radlat2) * Math.cos(radtheta)
    if (dist > 1) {
      dist = 1
    }
    dist = Math.acos(dist)
    dist = (dist * 180) / Math.PI
    dist = dist * 60 * 1.1515
    return dist
  }
}

import createPersistedState from "vuex-persistedstate"

export default new Vuex.Store({
  plugins: [
    createPersistedState({
      storage: window.sessionStorage,
      reducer: state => ({
        show: state.show,
        location: state.location,
        radius: state.radius,
        beds: state.beds,
        min_buy_price: state.min_buy_price,
        max_buy_price: state.max_buy_price,
        min_rent_price: state.min_rent_price,
        max_rent_price: state.max_rent_price,
        sort: state.sort
      })
    })
  ],
  state: {
    page: {},

    site_id: "lmh",
    misc: null,
    main_pages: null,
    top_menu: null,
    latest: [],
    properties: [],

    homeID: "ImeDDMQJZ",
    informationID: "RkH2ZyzWJ",
    mortgagesID: "H1rJERWri",
    portfolioID: "sHifJ6-BF",
    contactID: "BjspEVFto",
    privacyID: "8Sh4X_vFF",
    complaintsID: "b9j1W74BX",

    informationPage: null,
    mortgagesPage: null,
    portfolioPage: null,
    contactPage: null,
    privacyPage: null,
    complaintsPage: null,

    show: "",
    location: "",
    radius: "",
    beds: "",
    min_buy_price: "",
    max_buy_price: "",
    min_rent_price: "",
    max_rent_price: "",
    sort: "",

    propertiesPage: {
      ItemID: "properties",
      url: "our-developments",
      name: "Our Developments",
      title: "Our Developments"
    }
  },
  getters: {
    isHomePage(state) {
      return state.page.ItemID && state.page.ItemID == state.homeID
    },
    isPropertiesPage(state) {
      return state.page.ItemID && state.page.ItemID == "properties"
    },
    isProperty(state) {
      return state.page.ItemType && state.page.ItemType == "page.properties"
    },
    isContactPage(state) {
      return state.page.ItemID && state.page.ItemID == state.contactID
    }
  },
  mutations: {
    setPage(state, page) {
      state.page = page
    },
    setSearch(state, payload) {
      state.show = payload.show
      state.location = payload.location
      state.radius = payload.radius
      state.beds = payload.beds
      if (payload.min_buy_price) state.min_buy_price = payload.min_buy_price
      if (payload.max_buy_price) state.max_buy_price = payload.max_buy_price
      if (payload.min_rent_price) state.min_rent_price = payload.min_rent_price
      if (payload.max_rent_price) state.max_rent_price = payload.max_rent_price
      state.sort = payload.sort
    },
    setMisc(state, misc) {
      state.misc = misc
    },
    setProperties(state, properties) {
      properties = properties.filter(p => p.status != "Hidden")
      state.latest = properties.slice(0, 4)
      state.properties = properties
    },
    setPropertiesDistance(state, coords) {
      state.properties.forEach(p => {
        if (p._geo && p._geo.postcode)
          Vue.set(p, "_distance", distance(coords.lat, coords.lng, p._geo.postcode.lat, p._geo.postcode.lng))
      })
    },
    setMainPages(state, main_pages) {
      state.main_pages = main_pages
      state.top_menu = main_pages.filter(p => {
        return [state.privacyID, state.complaintsID].indexOf(p.ItemID) == -1
      })
    },
    setPageSubs(state, subs) {
      Vue.set(state.page, "subs", subs)
    }
  },
  actions: {
    getMisc({ commit, state }) {
      return new Promise(resolve => {
        if (!state.settings)
          api.getPageByItemID("MISC").then(misc => {
            commit("setMisc", misc)
            resolve()
          })
        else resolve()
      })
    },
    getProperties({ commit, state }) {
      return new Promise(resolve => {
        if (!state.settings)
          api
            .getPages(
              "images,street,key_features,area,price,bedrooms,#geo,build_type,highlight_text,#status",
              "page.properties",
              "",
              { "#geo": "_geo" },
              "",
              false
            )
            .then(properties => {
              commit("setProperties", properties)
              commit("setPropertiesDistance", initial_coords)
              resolve()
            })
        else resolve()
      })
    },
    getMainPages({ commit, state }) {
      return new Promise(resolve => {
        if (!state.main_pages)
          api.getPages("", "page.main").then(main_pages => {
            main_pages.splice(1, 0, state.propertiesPage)

            commit("setMainPages", main_pages)
            resolve()

            var promises = []

            main_pages.forEach(page => {
              if (page.ItemID == state.informationID) state.informationPage = page
              if (page.ItemID == state.mortgagesID) state.mortgagesPage = page
              if (page.ItemID == state.portfolioID) state.portfolioPage = page
              if (page.ItemID == state.contactID) state.contactPage = page
              if (page.ItemID == state.complaintsID) state.complaintsPage = page
              if (page.ItemID == state.privacyID) state.privacyPage = page

              if (page.ItemID != "properties")
                promises.push(api.getPages("", "page.sub=@" + page.ItemID).then(subs => Vue.set(page, "subs", subs)))
            })

            Promise.all(promises).then(() => {
              commit("setMainPages", main_pages)
            })
          })
        else resolve()
      })
    }
  }
})
